const channels = import.meta.glob('./**/*_channel.js', { eager: true })
// Node stuff
import deepmerge from "@node/deepmerge"

// Vue stuff
import { createApp as createVueApp } from "@node/vue/dist/vue.esm-bundler.js"
const app = createVueApp({})

import { createWebHistory, createRouter } from "@node/vue-router"
import { createI18n } from "@node/vue-i18n"

import vueDebounce from "@node/vue-debounce"
import VueCookies from "@node/vue-cookies"
import VueApexCharts from '@node/vue3-apexcharts'
import ElementPlus from "@node/element-plus"
import '@node/element-plus/theme-chalk/index.css'
import "@o-din/src/scss/index.scss"
// import ruLocale from "@node/element-ui/lib/locale/lang/ru-RU"
// import enLocale from "@node/element-ui/lib/locale/lang/en"
// import etLocale from "@node/element-ui/lib/locale/lang/ee"
// import esLocale from "@node/element-ui/lib/locale/lang/es"
import ActionCable from "@node/actioncable"
import { install } from "@node/vue3-recaptcha-v2"

// Base components
import AutoTable from "@o-din/src/components/AutoTable.vue"
import BasePage from "@o-din/src/components/BasePage.vue"
import DropdownMenu from "@o-din/src/components/DropdownMenu.vue"
import DateFilter from "@o-din/src/components/DateFilter.vue"
import ErrorsView from "@o-din/src/components/ErrorsView.vue"
import FilePicker from "@o-din/src/components/FilePicker.vue"
import IconPicker from "@o-din/src/components/IconPicker.vue"
import Modal from "@o-din/src/components/Modal.vue"
import MiniTable from "@o-din/src/components/MiniTable.vue"
import Paginator from "@o-din/src/components/Paginator.vue"
import PerPage from "@o-din/src/components/PerPage.vue"
import RichEditor from "@o-din/src/components/RichEditor.vue"
import SelectFilter from "@o-din/src/components/SelectFilter.vue"
import Switch from "@o-din/src/components/Switch.vue"
import SortableHeader from "@o-din/src/components/SortableHeader.vue"
import Tabs from "@o-din/src/components/Tabs.vue"
import TabPane from "@o-din/src/components/TabPane.vue"
import HelpIcon from "@o-din/src/components/HelpIcon.vue"
import BaseBtn from "@o-din/src/components/BaseBtn.vue"

app.component("auto-table", AutoTable);
app.component("base-page", BasePage);
app.component("dropdown-menu", DropdownMenu);
app.component("date-filter", DateFilter);
app.component("errors-view", ErrorsView);
app.component("file-picker", FilePicker);
app.component("icon-picker", IconPicker);
app.component("help-icon", HelpIcon);
app.component("base-btn", BaseBtn);
app.component("modal", Modal);
app.component("mini-table", MiniTable);
app.component("rich-editor", RichEditor);
app.component("paginator", Paginator);
app.component("per-page", PerPage);
app.component("select-filter", SelectFilter);
app.component("switcher", Switch);
app.component("tabs", Tabs);
app.component("tab-pane", TabPane);
app.component("sortable-header", SortableHeader);

// I18n (from rails locales)
let messages = {}

const modules = import.meta.glob("@o-din/../../config/locales/**/*.yml", { eager: true })

for (const path in modules) {
  messages = deepmerge(messages, modules[path].default)
}

// messages = deepmerge(messages, { ru: ruLocale })
// messages = deepmerge(messages, { en: enLocale })
// messages = deepmerge(messages, { et: etLocale })
// messages = deepmerge(messages, { es: esLocale })

if (process.env.HOST == 'localhost') {
  app.config.globalProperties.$cable = ActionCable.createConsumer(`ws://${process.env.HOST}:3000/cable?token=${VueCookies.get("auth_token")}`)
} else {
  app.config.globalProperties.$cable = ActionCable.createConsumer(`wss://${window.location.host}/cable?token=${VueCookies.get("auth_token")}`)
}

import core_routes from "@o-din/src/routes"
import configuration_menu from "@o-din/src/configuration_menu.json"
// adapter + store
import root_store from "@o-din/src/store"

import { ElDatePicker } from '@node/element-plus'

ElDatePicker.setPropsDefaults({
  format: 'DD.MM.YYYY',
})

export function createApp(el, modules) {
  let routes = core_routes;
  let store = Object.assign({}, root_store)
  let menu = [];

  modules.forEach((item, i) => {
    routes = routes.concat(item.routes || [])
    menu = menu.concat(item.menu || [])
    messages = deepmerge(messages, item.locales || {})
    Object.assign(store, item.store)
  });
  menu = menu.concat([configuration_menu] || [])

  app.config.globalProperties.$store = store
  app.config.globalProperties.$menu = menu
  app.config.compilerOptions.whitespace = "preserve"

  const i18n = createI18n({ locale: "en", messages })
  const router = createRouter({history: createWebHistory("/"), routes })
  app
    .use(ElementPlus, { i18n: (key, value) => i18n.t(key, value) })
    .use(vueDebounce)
    .use(router)
    .use(i18n)
    .use(VueApexCharts)
    .use(install, { sitekey: process.env.RECAPTCHA_SITE_KEY })
    .mount("#app")
}
